"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitUnlockDesignBomSuccess = exports.emitUnlockDesignBom = void 0;
const events_service_types_1 = require("@hip/events-service-types");
const createEmmiter_1 = require("../helpers/createEmmiter");
const emitUnlockDesignBom = (socket, request) => (0, createEmmiter_1.createEmitter)(socket, events_service_types_1.UNLOCK_DESIGN_BOM_EVENTS.UNLOCK_DESIGN_BOM, request);
exports.emitUnlockDesignBom = emitUnlockDesignBom;
const emitUnlockDesignBomSuccess = (socket, request) => (0, createEmmiter_1.createEmitter)(socket, events_service_types_1.UNLOCK_DESIGN_BOM_EVENTS.UNLOCK_DESIGN_BOM_SUCCESS, request);
exports.emitUnlockDesignBomSuccess = emitUnlockDesignBomSuccess;
